import { API_TAG_LIST, API_TAG_ADD, API_TAG_DELETE, API_FILE_DESC_UPDATE } from '@/common/constants';
import { get, post, del , put } from '@/utils/http';

export const getTags = (params = {}) => {
    return get(API_TAG_LIST, Object.assign({}, {
        currentPage: 1,
        pageSize: 1000
    }, params));
};

export const addTag = (tag) => {
  return post(API_TAG_ADD, tag);
};

export const deleteTag = (id) => {
    return del(API_TAG_DELETE.replace(':id', id));
};

export const updateFileDesc = (param) => {
    return put(API_FILE_DESC_UPDATE, param);
};


// WEBPACK FOOTER //
// ./src/data-model/system/tag-model.js